import React from 'react';
import {Link} from "gatsby";
import {FooterContainer, FooterMenuContainer, Label} from "./styled";
import BackgroundImage_Footer from "../BackgroundImage/Footer";
import routes, {routesFooter} from "../../routes";
import {ContactLinks, LinkContact, LinkGatsbyContact, Socials} from "../Home/styled";
import {injectIntl} from "gatsby-plugin-intl";

import logo from "../../images/svg/champion-logo.svg";
import iconSocialInstagram from "../../images/svg/socials/instagram.svg";
import iconSocialFacebook from "../../images/svg/socials/facebook.svg";
import iconPhone from "../../images/svg/icon-phone.svg";
import iconEmail from "../../images/svg/icon-email.svg";
import iconAddress from "../../images/svg/icon-address.svg";

const Footer = ({intl}) => {
  // Get the current language code
  const currentLanguageCode = intl?.locale;

  return (typeof window !== 'undefined') ? (
    <BackgroundImage_Footer
      name={ (window.innerWidth < 768)
        ? 'background-footer-mini'
        : 'background-footer'
      }
    >
      <FooterContainer>
        <div>
          <img
            src={logo}
            height={80}
          />

          <p>
            {intl.formatMessage({ id: "footer.description" })}
          </p>
        </div>

        <FooterMenuContainer>
          <Label>{intl.formatMessage({ id: "footer.title.pages" })}</Label>

          <ul>
            {routes?.map(route => (
              <li>
                <Link to={`/${currentLanguageCode}${route?.href}`}>
                  {intl.formatMessage({ id: `menu.${route?.slug}` })}
                </Link>
              </li>
            ))}
          </ul>
        </FooterMenuContainer>

        <FooterMenuContainer>
          <Label>{intl.formatMessage({ id: "button.buy-package" })}</Label>

          <ContactLinks>
            <LinkContact href={`tel:${process.env.GATSBY_PHONE}`}>
              <img src={iconPhone}/>

              {process.env.GATSBY_PHONE}
            </LinkContact>

            <LinkContact href={`mailto:${process.env.GATSBY_EMAIL}`}>
              <img src={iconEmail}/>

              {process.env.GATSBY_EMAIL}
            </LinkContact>

            <LinkGatsbyContact to={`/${currentLanguageCode}/contacts`}>
              <img src={iconAddress}/>

              New York, NY
            </LinkGatsbyContact>
          </ContactLinks>
        </FooterMenuContainer>

        <FooterMenuContainer>
          <Label>{intl.formatMessage({ id: "footer.title.social" })}</Label>

          <Socials>
            <div>
              <a
                href={process.env.GATSBY_INSTAGRAM}
                target={'_blank'}
              >
                <img src={iconSocialInstagram}/>
              </a>
            </div>

            <div>
              <a
                href={process.env.GATSBY_FACEBOOK}
                target={'_blank'}
              >
                <img src={iconSocialFacebook}/>
              </a>
            </div>

            {/*<div>*/}
            {/*  <img src={iconSocialTiktok}/>*/}
            {/*</div>*/}

            {/*<div>*/}
            {/*  <img src={iconSocialYoutube}/>*/}
            {/*</div>*/}
          </Socials>

          <ul style={{marginTop: 59}}>
            {routesFooter?.map(route => (
              <li>
                <Link to={`/${currentLanguageCode}${route?.href}`}>
                  {intl.formatMessage({ id: `menu.${route?.slug}` })}
                </Link>
              </li>
            ))}
          </ul>
        </FooterMenuContainer>
      </FooterContainer>
    </BackgroundImage_Footer>
  ) : null;
};

export default injectIntl(Footer)
